'use client';
import React, { useCallback } from 'react';
import { useWatchlistContext } from '@benzinga/user-context';
import { Watchlist } from '@benzinga/watchlist-manager';
import { WatchlistLinkInternal } from '@benzinga/pro-watchlist-widget';

export const PortfolioLinkModal = () => {
  const { setSelectedWatchlist, showYodleeModal, setShowYodleeModal } = useWatchlistContext();

  const closePortfolioLinkModal = useCallback(() => {
    setShowYodleeModal(false);
  }, [setShowYodleeModal]);

  const openWatchlist = useCallback(
    (watchlist: Watchlist) => {
      setSelectedWatchlist(watchlist);
    },
    [setSelectedWatchlist],
  );

  if (!showYodleeModal) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50">
      <WatchlistLinkInternal closeModal={closePortfolioLinkModal} linkedWatchlist={openWatchlist} />
    </div>
  );
};
